<template>
    <b-row class="site-footer" >
        <div class="site-footer__top">
            <ul class="site-footer__nav">
                <li ><a href="/about">Apie portalą</a></li>
                <li ><a href="/faq">DUK</a></li>
                <li ><a href="/query">Užklausa</a></li>
                <li ><a href="/help">Pagalba</a></li>
                <li ><a href="/policy">Privatumo politika</a></li>
                <li ><a href="/contacts">Kontaktai</a></li>
            </ul>
            <ul class="site-footer__share">
            </ul>
        </div>
        <div class="site-footer__bottom">
            <div class="site-footer__info">
                <img src="../assets/img/es-support-logo.png" alt="ES support logo"/>
                Projektas „Visuomenės poreikius atitinkančios virtualios kultūrinės erdvės vystymas“ įgyvendintas 2014–2020 metų Europos Sąjungos fondų investicijų veiksmų programos 2 prioriteto „Informacinės visuomenės skatinimas“ lėšomis
            </div>
            <a href="https://www.europeana.eu" target="_blank" class="site-footer__trusted">
                <img src="../assets/img/trusted-logo.png" alt="Europeana trust logo">
            </a>
        </div>
    </b-row>
</template>

<script>
export default {
  name: 'VepisFooter'
}
</script>

<style scoped>
.site-footer {
  background-color: var(--colorPrimary--dark-more);
  color: var(--color-font-light);
  display: flex;
  flex-direction: column;
  padding: 36px 44px;
  position: relative;
}

.site-footer__bottom, .site-footer__top {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-left: 30px;
    padding-right: 30px;
    width: 100%;
}

.site-footer__nav {
    align-items: center;
    flex-grow: 1;
    flex-wrap: wrap;
}

.site-footer__nav, .site-footer__share {
    display: flex;
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.site-footer__nav li, .site-footer__share li {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-right: 10px;
}

.site-footer__nav li a, .site-footer__share li a {
    color: var(--color-font-light);
    padding: 4px 8px 4px 0;
}

.site-footer__bottom {
    margin-top: 20px;
    position: relative;
}

.site-footer__bottom, .site-footer__top {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-left: 30px;
    padding-right: 30px;
    width: 100%;
}

.site-footer__info {
    align-items: center;
    display: flex;
    flex-grow: 1;
    font-size: .875em;
    line-height: 1.375em;
    max-width: 1280px;
}

.site-footer__info img {
    height: 44px;
    margin-right: 20px;
}

.site-footer__trusted {
    margin-left: 30px;
}
</style>
